<template>
  <div class="spinner">
    <font-awesome-icon
      icon="circle-notch"
      class="spinner__spinner"
      spin
    />
    <p
      v-show="text"
      v-html="text"
      class="spinner__text"
    />
  </div>
</template>

<script>

export default {
  name: 'Spinner',
  props: {
    text: {
      type: [String, Number],
      required: false,
      default () {
        return null
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
